import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { BooxService } from './boox.service';
import { BehaviorSubject, interval, Subject, tap } from 'rxjs';
import { IStringAnyMap } from '../app.types';
import * as _ from 'lodash';
import { MessageService } from './message.service';

export interface INotification {
  id : string;
  title: string;
  content: string;
  link ?: string;
}

export interface INotificationResponse {
  has_card: number;
  verify_card: number 
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public $notifications : BehaviorSubject<INotification[]> = new BehaviorSubject<INotification[]>([]);
  public $notificationCount : BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public $newNotification : Subject<boolean> = new Subject<boolean>();
  public $notificationVeriApp : Subject<INotification> = new Subject<INotification>();

  public get notifications() : INotification[] {
    return this.$notifications.getValue();
  }

  public get notificationCount() : number {
    return this.$notificationCount.getValue();
  }

  constructor(
    private session : SessionService,
    private boox : BooxService,
  ) {

    this.session.$session.subscribe((_session) => {
      if(_session) this._loadNotifications().subscribe();
    });

    interval(10000).subscribe(() => {
      this.loadNotifications();
    });
    
  }

  public loadNotifications() {
    if(this.session.session) {
      this._loadNotifications().subscribe();
    }
  }

  private _loadNotifications() {
    return this.boox.post<INotificationResponse>('kapa/_proc/get_notifications', {})
      .pipe(
        tap((_notifications : INotificationResponse) => {

          let currentNotifications = this.notifications;
          let currentNotificationCount = this.notificationCount;

          let no_cardCurrentNotifications = currentNotifications.filter((_notification) => _notification['id'] === 'no_card').length > 0;
          let verify_cardCurrentNotifications = currentNotifications.filter((_notification) => _notification['id'] === 'verify_card').length > 0;
        

          let notifications : INotification[] = [];
          let count = 0;
          let no_card : INotification|null = null;
          let verify_card : INotification|null = null;

          if(!_notifications.has_card) {
            no_card = {
              id : 'no_card',
              title: 'Keine KETCHCard',
              content: 'Du hast noch keine KETCHCard, bitte erstelle eine.',
              link: '/profile'
            };
            notifications.push(no_card);
            count += 1;
          }

          if(_notifications.verify_card > 0) {
            verify_card = {
              id : 'verify_card',
              title: 'KETCHCard nicht verifiziert',
              content: `Du hast <span class="fs-5">${_notifications.verify_card}</span> KETCHCard${(_notifications.verify_card>1)?'s':''} Deiner Mitarbeiter zu verifiziere.`,
              link: '/app/veri/changes'
            };
            notifications.push(verify_card);
            count += _notifications.verify_card;
          }

          if(
            (no_card && !no_cardCurrentNotifications) ||
            (verify_card && !verify_cardCurrentNotifications) ||
            (currentNotificationCount !== count)
          ) {
            
            this.$newNotification.next(true); 
            this.$notifications.next(notifications);
            this.$notificationCount.next(count);
            
            if(verify_card)
              this.$notificationVeriApp.next(verify_card);
          }
          else{
            this.$newNotification.next(false); 
          }
        })
      );
  }
}
